<template functional>
    <div class="tab-bar h-block bg-white border-b border-50 flex">
        <router-link
            v-for="(tab, index) in props.tabs"
            :key="index"
            class="flex-1 block text-center"
            :to="tab.route">
            <span>
                <component
                    :is="injections.components.StarredItem"
                    :starred="tab.meta && tab.meta.notOnFreePlan && props.isOnFreePlan"
                >
                    <span class="h-block">
                        {{ tab.title }}
                    </span>
                </component>
            </span>
        </router-link>
    </div>
</template>

<script>
import StarredItem from '@mobile/components/StarredItem';

export default {
    inject: {
        components: {
            default: {
                StarredItem,
            },
        },
    },

    props: {
        tabs: {
            type: Array,
            required: true,
        },
        isOnFreePlan: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
